import ls from 'local-storage';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { COMMON_LOCAL_STORAGE_CACHE_KEY } from '../constants/localStorageConstants';
import { getRequestAsJS } from '../selectors/requestSelectors';
import { COMMON_CACHE_VERSION } from '../constants/cacheConstants';

const saveCommonCacheThunk = () => (dispatch, getState) => {
  const state = getState();
  const {
    location, startDate, endDate,
  } = getRequestAsJS(state);
  ls.set(COMMON_LOCAL_STORAGE_CACHE_KEY, {
    from: {},
    to: {
      id: location?.id,
      name: location?.name,
      label: location?.label,
      query: location?.query,
      airportCode: location?.airportCode,
      type: location?.type,
    },
    startDate,
    endDate,
    locale: getActiveLocaleSelector(state),
    timestamp: Date.now(),
    version: COMMON_CACHE_VERSION,
  });
};

export default saveCommonCacheThunk;
